import React from "react";
import { FaFacebookF, FaTwitter, FaVimeoV, FaInstagram } from "react-icons/fa";
import "./SocialBtns.css";

export default function SocialBtns({ variant }) {
  return (
    <div className={`social-btns ${variant ? variant : ""}`}>
      <a
        href="https://www.facebook.com/riyanshsolarpowerplus"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon facebook"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://twitter.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon twitter"
      >
        <FaTwitter />
      </a>

      {/* <a
        href="https://vimeo.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon vimeo"
      >
        <FaVimeoV />
      </a> */}

      <a
        href="https://www.instagram.com/official_riyanshsolarpowerplus/#"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon instagram"
      >
        <FaInstagram />
      </a>
    </div>
  );
}
